import TileLayer from 'ol/layer/Tile'
import XYZ from 'ol/source/XYZ'

export const BASEMAP_KEYS = ['streets', 'satellite', 'terrain'] as const
export type BasemapKey = (typeof BASEMAP_KEYS)[number]

export const BASEMAP_LABELS: Record<BasemapKey, string> = {
  streets: 'Streets',
  satellite: 'Satellite',
  terrain: 'Terrain',
}

const SOURCES: Record<BasemapKey, { url: string; attributions: string }> = {
  streets: {
    url: 'https://{a-d}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
    attributions: '© OpenStreetMap · © CARTO',
  },
  satellite: {
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attributions: 'Esri',
  },
  terrain: {
    url: 'https://{a-c}.tile.opentopomap.org/{z}/{x}/{y}.png',
    attributions: 'OpenTopoMap',
  },
}

/** Three tile layers, streets visible by default. Add all once; toggle visibility to switch. */
export function buildBasemapLayers(): Record<BasemapKey, TileLayer<XYZ>> {
  return Object.fromEntries(
    BASEMAP_KEYS.map((key) => {
      const layer = new TileLayer({
        source: new XYZ({ ...SOURCES[key], crossOrigin: 'anonymous', cacheSize: 512 }),
        zIndex: 0,
        visible: key === 'streets',
        preload: 2,
        useInterimTilesOnError: true,
      })
      layer.set('id', `gis-basemap-${key}`)
      return [key, layer]
    }),
  ) as Record<BasemapKey, TileLayer<XYZ>>
}
